export const starter2Apil = 'https://localhost:5001';
export const crmApil = 'https://develop.adserve.studio/api/crm';
export const crmApi = `${window.origin}/api/crm`;
export const starter2Api = `${window.origin}/api/starter2`;

export const planningUi = `${window.origin}/planning`;
export const campaignManagerUi = `${window.origin}/campaign-manager`;
export const crmUi = `${window.origin}/crm`;

export const RedirectURL = (pathname) => {
    return `${window.origin}/${pathname}`;
};
